import styles from "./AscCompetitionWonItem.module.scss";
import { AscCompetitionWonItemPropsI } from "./AscCompetitionWonItem.type";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { CalendarEmptyIcon } from "../AscIcons";
import AscTag from "../AscTag/AscTag";
import { getOrdinalNumberSuffix } from "../../lib/helpers/functions/getOrdinalNumberSuffix/getOrdinalNumberSuffix";
import AscImage from "../AscImage/AscImage";

dayjs.extend(relativeTime);

function AscCompetitionWonItem({
  imageUrl,
  competitionName,
  rank,
  date,
}: AscCompetitionWonItemPropsI) {
  const numberSuffix = getOrdinalNumberSuffix(rank);
  const tagLabel = `${rank + numberSuffix} place`;

  function getTag(rank: number) {
    switch (rank) {
      case 1:
        return (
          <AscTag
            className={styles.tag}
            type={"competition-first"}
            label={tagLabel}
          />
        );
      case 2:
        return (
          <AscTag
            className={styles.tag}
            type={"competition-second"}
            label={tagLabel}
          />
        );
      case 3:
        return (
          <AscTag
            className={styles.tag}
            type={"competition-third"}
            label={tagLabel}
          />
        );
      default:
        return (
          <AscTag
            className={styles.tag}
            type={"competition-other"}
            label={tagLabel}
          />
        );
    }
  }

  return (
    <div className={styles.element}>
      <div className={styles.leftColumn}>
        <div className={styles.imageWrapper}>
          <AscImage
            className={styles.image}
            src={imageUrl}
            alt={"competition thumbnail"}
          />
        </div>
        <div className={styles.contentWrapper}>
          <div className={styles.name}>{competitionName}</div>
          {getTag(rank)}
        </div>
      </div>

      <div className={styles.rightColumn}>
        <div className={styles.dateContent}>
          <CalendarEmptyIcon className={styles.calendarIcon} />
          {date && (
            <div className={styles.date}>
              {dayjs(date).format("D MMMM YYYY")}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default AscCompetitionWonItem;
